module.exports = __webpack_public_path__ + "img/801_26@2x.22a9c3de.png";